import React from 'react'
import Banner from './banner'
import PackageList from './packageList'
import JoinWest from './joinWest'
import Travellers from './travellers'

const Home = () => {
    return (
        <div>
            <Banner />
            <PackageList />
            <JoinWest />
            <Travellers />
        </div>
    )
}

export default Home
